import script from "./ContactBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactBox.vue?vue&type=script&setup=true&lang=ts"

import "./ContactBox.vue?vue&type=style&index=0&id=dd7b6abe&lang=css"

const __exports__ = script;

export default __exports__